module.exports = __webpack_public_path__ + "static/img/yinhang.31f0325.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yinhang.png
// module id = 4Dt9
// module chunks = 128